import * as space from './space';
import * as environment from './environment';
import * as entry from './entry';
import * as asset from './asset';
import * as contentType from './content-type';
import * as editorInterface from './editor-interface';
import * as locale from './locale';
import * as webhook from './webhook';
import * as spaceMembership from './space-membership';
import * as organizationMembership from './organization-membership';
import * as role from './role';
import * as apiKey from './api-key';
import * as previewApiKey from './preview-api-key';
import * as upload from './upload';
import * as organization from './organization';
import * as uiExtension from './ui-extension';
import * as snapshot from './snapshot';
import * as user from './user';
import * as personalAccessToken from './personal-access-token';
import * as usage from './usage';
import * as environmentAlias from './environment-alias';

export default {
  space: space,
  environment: environment,
  entry: entry,
  asset: asset,
  contentType: contentType,
  editorInterface: editorInterface,
  locale: locale,
  webhook: webhook,
  spaceMembership: spaceMembership,
  organizationMembership: organizationMembership,
  role: role,
  apiKey: apiKey,
  previewApiKey: previewApiKey,
  upload: upload,
  organization: organization,
  uiExtension: uiExtension,
  snapshot: snapshot,
  user: user,
  personalAccessToken: personalAccessToken,
  usage: usage,
  environmentAlias: environmentAlias
};